import React from 'react';
import { Col, Space } from 'antd';

const StatusBtn = ({ count, active, disabled, text, color, onClick }) => 
    <Col 
        onClick={disabled ? undefined : onClick}
        style={{
            height: 100,
            width: 180,
            borderRadius: '0.5rem',
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: active ? '#1890ff' : '#d9d9d9',
            color: active ? '#1890ff' : 'black',
            cursor: disabled ? 'not-allowed' : 'pointer'
        }}>
        <Space direction="horizontal">
            <div style={{ height: 100, width: 14, background: color }} />
            <Space direction="vertical" align="center" style={{ width: 136 }}>
                <span>{text}</span>
                <span>{count}</span>
            </Space>
        </Space>
    </Col>

export default StatusBtn;
